export const firebaseConfigProd = {
    apiKey: "AIzaSyB1KJOwGwzcG35BUOuHGPaESSrNYd7LF7o",
    authDomain: "dihdah.firebaseapp.com",
    projectId: "dihdah",
    storageBucket: "dihdah.appspot.com",
    messagingSenderId: "728491969375",
    appId: "1:728491969375:web:86c7b06cb5bc5dda1544ea",
    measurementId: "G-Z54K1KSCKG"
  };
  